export function isEmpty(value: any) {
  if (Array.isArray(value)) {
    return !value.length;
  }
  return value === undefined || value === null || value === "";
}
